/***********************************************/
// Capa de Servicios para el modulo de Ciudades.

import axios from "axios";
import store from "@/store/store.js";

export default new class {

    #baseUrl = null;
    errormsg = '';
    message = null;
    header = {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: 'Bearer ' + store.getters.getToken
        }
    };

    constructor() {
        // Inicializar campos y propiedades.
        this.#baseUrl = store.getters.getBaseURL;
    }

    async getProfiles() {
        try {
            let response = await axios.get(this.#baseUrl + "/profiles");
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getCountRecords(module) {
        try {
            let response = await axios.get(`${this.#baseUrl}/count-records/${module}`);
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getTotalDoctorsSpecialties() {
        try {
            let response = await axios.get(this.#baseUrl + "/count-records/specialties");
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getCountRecordsTags() {
        try {
            let response = await axios.get(`${this.#baseUrl}/count-records/preferences`);
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getCountTags(tag_type) {
        try {
            let formData = new FormData();
            formData.append("tag", tag_type);
            let response = await axios.get(`${this.#baseUrl}/count-tag/preferences?tag=${tag_type}`);
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getTotaltVisits() {
        try {
            let response = await axios.get(`${this.#baseUrl}/total-visits/visits`);
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getCountVisits(device_type) {
        try {
            let formData = new FormData();
            formData.append("device", device_type);
            let response = await axios.get(`${this.#baseUrl}/count-visits/visits?device=${device_type}`);
            return response.data.value;
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getRecientContacts() {
        try {
            let response = await axios.get(this.#baseUrl + "/view-list-recents/contacts");
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

    async getRecientComments() {
        try {
            let response = await axios.get(this.#baseUrl + "/view-list-recents/comments");
            if (response.data.success) {
                return response.data;
            } else {
                return null;
            }
        } catch (error) {
            return this.handleError(error);
        }
    }

}